import { AppVersionType } from "./appVersionType";
import { initialState } from "./initialState";

export const appVersionReducer = {
  resetStatusInfo: (state: AppVersionType) => {
    state.statusCode = null;
    state.success = null;
    state.message = null;
    state.error = null;
  },
  resetAppVersionSlice: () => initialState,
};
